import styles from './Dropdown.module.css';

const DropdownItem = ({ children, onclick }) => {
    return (
        <div className={`dropdown-item ${styles.item}`} onClick={onclick} >
            {children}
        </div>
    )
}

export default DropdownItem